import {Injectable, Injector} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "src/environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CacheService} from "../modules/shared/services/cache.service";
import {Translation} from "../interfaces/translation.interface";
import {TranslateService} from "@ngx-translate/core";
import {AppVersionInfo} from "../interfaces/appVersion.interface";

@Injectable({
  providedIn: "root",
})
export class AppService {
  private readonly apiDomain: string = environment.apiDomain;
  private translateService!: TranslateService;

  constructor(
    private readonly http: HttpClient,
    private readonly cacheService: CacheService,
    private readonly injector: Injector
  ) {}

  public getAppVersion(): Observable<AppVersionInfo> {
    return this.http.get<AppVersionInfo>(`${this.apiDomain}/version`).pipe(
      map((res) => {
        if (res) {
          this.cacheService
            .addToCache(`app_version`, res.version, 43200)
            .catch((err) => console.error("Cache write failed:", err));
          return res;
        }
        return {version: "0", changelog: ""};
      })
    );
  }

  public refreshTranslations(lang: string, translations: Translation): void {
    this.translateService ??= this.injector.get(TranslateService);
    this.translateService.setTranslation(lang, translations, true);
  }
}
